export var EnumConditions;
(function (EnumConditions) {
    EnumConditions[EnumConditions["NotEqualTo"] = 0] = "NotEqualTo";
    EnumConditions[EnumConditions["EqualTo"] = 1] = "EqualTo";
    EnumConditions[EnumConditions["GreaterThan"] = 2] = "GreaterThan";
    EnumConditions[EnumConditions["GreaterThanOrEqualTo"] = 3] = "GreaterThanOrEqualTo";
    EnumConditions[EnumConditions["LessThan"] = 4] = "LessThan";
    EnumConditions[EnumConditions["LessThanOrEqualTo"] = 5] = "LessThanOrEqualTo";
})(EnumConditions || (EnumConditions = {}));
